import cn from 'classnames';
import { type Product } from '@/domain/Product';
import styles from './ProductSpecificationSection.module.scss';
import CoffeeSpecification from './parts/CoffeeSpecification.tsx';
import SkeletonText from '@/widgets/components/controls/Skeleton/SkeletonText.tsx';

type ProductSpecificationSectionProps = {
  product: Product;
  class?: string;
};
export default function ProductSpecificationSection({
  product,
  class: className = ''
}: ProductSpecificationSectionProps) {
  if (product.type === 'capsule') {
    return <CoffeeSpecification product={product} />;
  }
  // @todo - waiting for machine/accessory card design
  return <div class={cn(styles.label, className)} />;
}

ProductSpecificationSection.Skeleton = function Skeleton() {
  return (
    <div class={styles.skeleton}>
      <SkeletonText />
      <SkeletonText />
    </div>
  );
};
